import { AdminOperationalAlertsScreen } from '@features/admin/ui/AdminOperationalAlertsScreen'

export function AlertasPage() {
  return <AdminOperationalAlertsScreen />
}
